import { render, staticRenderFns } from "./DisplayMoreBtn.vue?vue&type=template&id=6b7503ca&scoped=true&"
import script from "./DisplayMoreBtn.vue?vue&type=script&lang=js&"
export * from "./DisplayMoreBtn.vue?vue&type=script&lang=js&"
import style0 from "./DisplayMoreBtn.vue?vue&type=style&index=0&id=6b7503ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7503ca",
  null
  
)

export default component.exports